<template>
	<ContainedSection :has-padding="false">
		<div
			class="relative m-auto"
			:class="[
				containerClass,
				isVehiclePage
					? 'xl:rounded-md'
					: whitelabel.styles?.bg?.borderRadius,
				bgColourClass,
				hasBackground ? 'bg-no-repeat' : '',
				hasBackground ? bgImgAdditionalClass : '',
			]"
			:style="{ backgroundImage: bgImage }"
		>
			<slot />
		</div>
	</ContainedSection>
</template>

<script setup>
import ContainedSection from '@/components/sections/ContainedSection.vue'

const props = defineProps({
	containerClass: {
		type: String,
		default: '',
		required: false,
	},
	isVehiclePage: {
		type: Boolean,
		default: false,
		required: false,
	},
	bgImageUrl: {
		type: String,
		required: false,
	},
	bgImageMobileUrl: {
		type: String,
		required: false,
	},
	bgImgAdditionalClass: {
		type: String,
		default:
			'h-[750px] md:h-[650px] lg:h-[600px] bg-cover md:bg-cover md:bg-[left_top_-8rem] lg:bg-center',
		required: false,
	},
	bgColourClass: {
		type: String,
		default: 'bg-white',
		required: false,
	},
})

const { whitelabel } = useWhitelabelsStyles('auroraenergy')

const hasBackground = computed(() => !!props.bgImageUrl)

const img = useImage()

const { bgImage } = useResponsiveBgImage(
	img(props.bgImageUrl),
	img(props.bgImageMobileUrl)
)
</script>
